import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '../../utils/cn'

const buttonVariants = cva(
  'inline-flex items-center justify-center whitespace-nowrap rounded-button disabled:pointer-events-none',
  {
    variants: {
      variant: {
        general:
          'text-content-defult hover:text-brand-primary-hover hover:bg-overlay-ghost-hover',
        primary:
          'bg-button-primary-default text-button-primary-text hover:bg-button-primary-hover focus:bg-button-primary-active disabled:bg-button-primary-disabled disabled:text-button-primary-text-disabled',
        subtle:
          'text-content-subtle hover:bg-overlay-ghost-hover hover:text-brand-primary-hover',
        dark: 'bg-overlay-dark-overlay-button-defualt text-content-inverse hover:bg-overlay-dark-overlay-button-hover', // TODO: Need disabled color
        light:
          'bg-overlay-light-overlay-button-defualt text-content-default hover:bg-overlay-light-overlay-button-hover',
        white:
          'bg-neutral-level-1-default text-content-default hover:text-brand-primary-hover',
        grey: 'bg-neutral-level-2-default text-content-default hover:text-brand-primary-hover',
      },
      size: {
        lg: 'h-button-lg w-button-lg',
        md: 'h-button-md w-button-md',
        sm: 'h-button-sm w-button-sm',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
    },
  }
)

type ButtonSize = 'sm' | 'md' | 'lg'
export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  size?: ButtonSize
  asChild?: boolean
}

const IconButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size = 'md', asChild = false, ...props }, ref) => {
    const Comp = 'button'
    return (
      <Comp
        className={cn(buttonVariants({ variant, className, size }))}
        ref={ref}
        {...props}
      >
        {props.children}
      </Comp>
    )
  }
)
IconButton.displayName = 'IconButton'

export { IconButton, buttonVariants }
